import { render, staticRenderFns } from "./InvitationComponent.vue?vue&type=template&id=3bde180b&"
import script from "./InvitationComponent.vue?vue&type=script&lang=js&"
export * from "./InvitationComponent.vue?vue&type=script&lang=js&"
import style0 from "./InvitationComponent.vue?vue&type=style&index=0&id=3bde180b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports